<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <div class="page">
      <!-- 选择栏 -->
      <div class="img1"><img src="@/assets/代表工程/利咸高速.jpg" alt="">
        <div class="img1title">利咸高速</div></div>
      <div class="modetitle">
        <div class="gang"></div>
        <span>代表工程</span>
        <div class="gang"></div>
      </div>
      <div class="selection-bar">
        <div
          v-for="category in categories"
          :key="category.name"
          :class="['selection-item', { active: selectedCategory === category.name }]"
          @click="selectCategory(category.name)"
        >
          {{ category.name }}
        </div>
      </div>

      <div class="mode">
        <div class="mode1">
          <div class="modepage">
            <!-- 遍历当前分类下的所有工程 -->
            <div
              v-for="project in selectedCategoryProjects"
              :key="project.name"
              class="contact"
            >
              <div class="conimg">
                <img :src="project.image" :alt="project.name">
                <div class="conitem">{{ project.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'EngineeringIndex',
  components: {
    TopNav, // 注册 TopNav 组件
    FootIndex
  },
  data () {
    return {
      selectedCategory: '公路工程', // 默认选中的分类
      categories: [
        {
          name: '公路工程',
          projects: [
            { name: '咸九高速', image: require('@/assets/代表工程/咸九高速.jpeg'), path: '/project/xianjiu' },
            { name: '利咸高速', image: require('@/assets/代表工程/利咸高速.jpg'), path: '/project/lixian' } // 新增利咸高速
          ]
        },
        {
          name: '桥隧工程',
          projects: [
            { name: '松枝长江大桥', image: require('@/assets/代表工程/松枝长江大桥.jpeg'), path: '/project/songzhi' },
            { name: '燕矶长江大桥', image: require('@/assets/代表工程/燕矶长江大桥.jpeg'), path: '/project/yanji' }
          ]
        },
        {
          name: '空港工程',
          projects: [
            { name: '武汉天河机场', image: require('@/assets/代表工程/武汉天河机场.jpeg'), path: '/project/tianhe' },
            { name: '鄂州花湖机场', image: require('@/assets/代表工程/鄂州花湖机场.jpeg'), path: '/project/ezhou' }
          ]
        },
        {
          name: '市政工程',
          projects: [
            { name: '深圳地铁13号线', image: require('@/assets/代表工程/深圳地铁13号线.jpeg'), path: '/project/shenzhen' },
            { name: '竹山城北绿色地毯产业园', image: require('@/assets/代表工程/竹山城北绿色地毯产业园.jpg'), path: '/project/zhushan' } // 新增竹山城北绿色地毯产业园
          ]
        }
      ]
    }
  },
  computed: {
    // 获取当前选中分类下的所有工程
    selectedCategoryProjects () {
      const category = this.categories.find(cat => cat.name === this.selectedCategory)
      return category ? category.projects : []
    }
  },
  methods: {
    // 选择分类
    selectCategory (categoryName) {
      this.selectedCategory = categoryName
    }
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page {
  padding-top: 100px;
}

.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.selection-bar {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.selection-item {
  padding: 10px 20px;
  margin: 0 10px;
  cursor: pointer;
  font-size: 16px;
  font-family: SimSun;
  font-weight: bold;
  color: #000;
  border-bottom: 2px solid transparent;
}

.selection-item.active {
  border-bottom: 2px solid #004da0;
  font-weight: bold;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}

.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap; /* 允许内容换行 */
  border-top: 0.002rem solid rgb(220, 220, 220);
}

.contact {
  margin: 20px;
  width: 40%; /* 每个工程占 40% 宽度 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}

.conimg {
  width: 100%;
  overflow: hidden;
}

.conimg img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  object-position: center;
}

.conitem {
  width: 100%;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background-color: rgb(237, 235, 235);
}
</style>
